import { render, staticRenderFns } from "./IssueSummary.vue?vue&type=template&id=b3e8365c"
import script from "./IssueSummary.vue?vue&type=script&lang=js"
export * from "./IssueSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports